/**
 * theme.js - the print-like palette, type and layout tokens for the public
 * sign-off sheet, plus its responsive CSS. This page is deliberately its own
 * visual world (paper, hairlines, condensed type) and shares nothing with the
 * app shell, so the tokens live here rather than in the app theme.
 */

export const GREEN = '#1B5E20';
export const AMBER_MARK = '#C08A00';
export const AMBER_TEXT = '#6B4E00';
export const AMBER_BAND = '#FBF6E6';
export const SURROUND = '#EEEDE7';
export const PAPER = '#FAFAF8';
export const SHEET_EDGE = '#DDDCD3';
export const RULE = '#C4C3B7';
export const HAIRLINE = '#E2E1D8';
export const LEADER = '#BEBDB0';
export const TRACK = '#E2E1D8';
export const INK = '#1A1A17';
export const INK_SOFT = '#3C3C35';
export const GREY = '#6D6D62';
export const GREY_LIGHT = '#95958B';

export const FONT = "'Montserrat', -apple-system, 'Segoe UI', Roboto, sans-serif";
export const CONDENSED = "'Arial Narrow', 'Helvetica Neue Condensed', 'Roboto Condensed', 'Montserrat', Arial, sans-serif";
export const MAX_W = 880;
export const PHASE_PREVIEW = 5;
export const PAGE_OPENED = Date.now();

export const LABEL = {
  fontSize: 9.5,
  fontWeight: 800,
  letterSpacing: '1.9px',
  textTransform: 'uppercase',
  color: GREEN,
};
export const SUBLABEL = {
  fontSize: 8.5,
  fontWeight: 800,
  letterSpacing: '1.7px',
  textTransform: 'uppercase',
  color: GREY_LIGHT,
};

// Only the handful of properties that must change between screen widths live
// here; everything else stays inline (inline styles would win over a media

export const CSS = `
.svm-sheet { box-sizing: border-box; padding: 32px 38px 24px; }
.svm-title { display: flex; align-items: flex-start; justify-content: space-between; gap: 20px; flex-wrap: wrap; }
.svm-metaRow { display: flex; align-items: baseline; justify-content: flex-end; gap: 12px; padding: 1.5px 0; }
.svm-metaVal { text-align: right; }
.svm-pct { font-size: 58px; }
.svm-zone { padding-left: 15px; border-left: 1px solid ${HAIRLINE}; }
.svm-foot { display: flex; align-items: baseline; justify-content: space-between; gap: 14px; flex-wrap: wrap; }
.svm-ident { display: block; }
@media (max-width: 640px) {
  .svm-sheet { padding: 20px 15px 18px; }
  .svm-metaRow { justify-content: flex-start; }
  .svm-metaVal { text-align: left; }
  .svm-pct { font-size: 44px; }
  .svm-zone { padding-left: 10px; }
  .svm-ident { display: none; }
}
`;

/* ---------------------------------- helpers ---------------------------------- */
